import type { ReactNode } from 'react';
import { useState } from 'react';
import { modelState, ModelStateList } from '@/utils/modelState';
import { useModelState } from '@/utils/useModelState';

export function NumericConditionComponent({ operator, value }: NumericConditionComponentProps ) {

    const [, setOperator] = useModelState(operator);
    const [, setValue] = useModelState(value);

    return (
        <div className="flex flex-row gap-2">
            <div>
                <select className="form-control" value={operator.value} onChange={e => setOperator(e.target.value)}>
                    <option value="gt">&gt;</option>
                    <option value="gte">&gt;=</option>
                    <option value="lt">&lt;</option>
                    <option value="lte">&lt;=</option>
                    <option value="eq">=</option>
                </select>
            </div>
            <div>
                <input className="form-control" type="number" value={value.value} onChange={e => setValue(Number(e.target.value))} />
            </div>
        </div>
    );
}

export interface NumericConditionComponentProps {
    operator: modelState<string>;
    value: modelState<number>;
}
